import React, { FC } from "react";
import { InternalLink } from "@pepdirect/v3/ui/InternalLink";
import {
  StyledBreadcrumbLink,
  StyledBreadcrumbs,
  StyledCaret,
} from "./index.styled";
import { CaretIconSvg, CaretPointDirections } from "@pepdirect/v3/ui/icons";
import { useScreenSize } from "@pepdirect/v3/hooks/useScreenSize";

interface BreadcrumbsProps {
  crumbs: Crumb[];
}

export interface Crumb {
  display: string;
  href?: string;
}

export const PortalBreadcrumbs: FC<BreadcrumbsProps> = ({
  crumbs: crumbsFromProps,
}) => {
  const { isMobile } = useScreenSize();

  let crumbs = crumbsFromProps;
  if (isMobile && crumbsFromProps.length > 2) {
    crumbs = [
      crumbsFromProps[0],
      { display: "..." },
      crumbsFromProps[crumbsFromProps.length - 1],
    ];
  }

  return (
    <StyledBreadcrumbs>
      {crumbs.map(({ display, href }, index) => {
        const key = `${display.slice(0).replace(/\s/g, "")}-${index}`;
        if (index === crumbs.length - 1) {
          // last one, so no ">" sign and no link
          return (
            <span key={key} data-testid="breadcrumbs-last-crumb">
              {display}
            </span>
          );
        } else if (!href) {
          return (
            <span key={key}>
              <span>{display}</span>
              <StyledCaret>
                <CaretIconSvg
                  pointDirection={CaretPointDirections.right}
                  width="16px"
                  height="10px"
                />
              </StyledCaret>
            </span>
          );
        } else {
          return (
            <span key={key}>
              <StyledBreadcrumbLink>
                <InternalLink href={href}>{display}</InternalLink>
              </StyledBreadcrumbLink>
              <StyledCaret>
                <CaretIconSvg
                  pointDirection={CaretPointDirections.right}
                  width="16px"
                  height="10px"
                />
              </StyledCaret>
            </span>
          );
        }
      })}
    </StyledBreadcrumbs>
  );
};
